export type MathAccessibleLabelConverter = (latex: string) => string | null;

export const stripAccessibleLabel = (value: any): string => String(value || '')
  .replace(/<[^>]*>/g, ' ')
  .replace(/[*_~`]/g, '')
  .replace(/\s+/g, ' ')
  .trim();

export const getElementAccessibleLabel = (
  element: any,
  convertMath: MathAccessibleLabelConverter,
): string => {
  if (element?.elementType === 'math' && element.latex && convertMath) {
    try {
      const mathLabel = convertMath(element.latex);
      if (mathLabel) return stripAccessibleLabel(mathLabel);
    }
    catch (e) {
      // Fall back to the element's configured text when math speech is unavailable.
    }
  }

  return stripAccessibleLabel(
    element && (element.caption || element.content || element.altText || element.latex) || '',
  );
};
